// source: protobuf/deal_transporter_direction_note/deal_transporter_direction_note.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var protobuf_validate_validate_pb = require('../../protobuf/validate/validate_pb.js');
goog.object.extend(proto, protobuf_validate_validate_pb);
var protobuf_filter_counters_pb = require('../../protobuf/filter/counters_pb.js');
goog.object.extend(proto, protobuf_filter_counters_pb);
var protobuf_filter_export_pb = require('../../protobuf/filter/export_pb.js');
goog.object.extend(proto, protobuf_filter_export_pb);
var protobuf_filter_request_pb = require('../../protobuf/filter/request_pb.js');
goog.object.extend(proto, protobuf_filter_request_pb);
var protobuf_model_merged_pb = require('../../protobuf/model/merged_pb.js');
goog.object.extend(proto, protobuf_model_merged_pb);
goog.exportSymbol('proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse', null, global);
goog.exportSymbol('proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.repeatedFields_, null);
};
goog.inherits(proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.displayName = 'proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.displayName = 'proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.displayName = 'proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.displayName = 'proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.repeatedFields_, null);
};
goog.inherits(proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.displayName = 'proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.displayName = 'proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.displayName = 'proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.repeatedFields_, null);
};
goog.inherits(proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.displayName = 'proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.displayName = 'proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.displayName = 'proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest;
  return proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse;
  return proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.DeleteDealTransporterDirectionNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dealId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    transporterDirectionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest;
  return proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransporterDirectionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDealId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransporterDirectionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string deal_id = 1;
 * @return {string}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.getDealId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.setDealId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string transporter_direction_id = 2;
 * @return {string}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.getTransporterDirectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.setTransporterDirectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.CreateDealTransporterDirectionNoteRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dealId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    transporterDirectionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    message: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest;
  return proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransporterDirectionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDealId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransporterDirectionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string deal_id = 1;
 * @return {string}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.getDealId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.setDealId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string transporter_direction_id = 2;
 * @return {string}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.getTransporterDirectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.setTransporterDirectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest} returns this
 */
proto.deal_transporter_direction_note.UpdateDealTransporterDirectionNoteRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest;
  return proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsMap: (f = msg.getItemsMap()) ? f.toObject(includeInstance, proto.model.DealTransporterDirectionNoteResponse.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse;
  return proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getItemsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.model.DealTransporterDirectionNoteResponse.deserializeBinaryFromReader, "", new proto.model.DealTransporterDirectionNoteResponse());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.model.DealTransporterDirectionNoteResponse.serializeBinaryToWriter);
  }
};


/**
 * map<string, model.DealTransporterDirectionNoteResponse> items = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.model.DealTransporterDirectionNoteResponse>}
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.prototype.getItemsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.model.DealTransporterDirectionNoteResponse>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.model.DealTransporterDirectionNoteResponse));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse} returns this
 */
proto.deal_transporter_direction_note.GetDealTransporterDirectionNotesResponse.prototype.clearItemsMap = function() {
  this.getItemsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dealId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    transporterDirectionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    filter: (f = msg.getFilter()) && protobuf_filter_request_pb.Request.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest;
  return proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransporterDirectionId(value);
      break;
    case 5:
      var value = new protobuf_filter_request_pb.Request;
      reader.readMessage(value,protobuf_filter_request_pb.Request.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDealId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransporterDirectionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      protobuf_filter_request_pb.Request.serializeBinaryToWriter
    );
  }
};


/**
 * optional string deal_id = 1;
 * @return {string}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.getDealId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.setDealId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string transporter_direction_id = 2;
 * @return {string}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.getTransporterDirectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.setTransporterDirectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional filter.Request filter = 5;
 * @return {?proto.filter.Request}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.getFilter = function() {
  return /** @type{?proto.filter.Request} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_request_pb.Request, 5));
};


/**
 * @param {?proto.filter.Request|undefined} value
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} returns this
*/
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    counters: (f = msg.getCounters()) && protobuf_filter_counters_pb.Counters.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    protobuf_model_merged_pb.DealTransporterDirectionNoteResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse;
  return proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new protobuf_filter_counters_pb.Counters;
      reader.readMessage(value,protobuf_filter_counters_pb.Counters.deserializeBinaryFromReader);
      msg.setCounters(value);
      break;
    case 2:
      var value = new protobuf_model_merged_pb.DealTransporterDirectionNoteResponse;
      reader.readMessage(value,protobuf_model_merged_pb.DealTransporterDirectionNoteResponse.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCounters();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      protobuf_filter_counters_pb.Counters.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      protobuf_model_merged_pb.DealTransporterDirectionNoteResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional filter.Counters counters = 1;
 * @return {?proto.filter.Counters}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.getCounters = function() {
  return /** @type{?proto.filter.Counters} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_counters_pb.Counters, 1));
};


/**
 * @param {?proto.filter.Counters|undefined} value
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} returns this
*/
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.setCounters = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} returns this
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.clearCounters = function() {
  return this.setCounters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.hasCounters = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated model.DealTransporterDirectionNoteResponse items = 2;
 * @return {!Array<!proto.model.DealTransporterDirectionNoteResponse>}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.model.DealTransporterDirectionNoteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, protobuf_model_merged_pb.DealTransporterDirectionNoteResponse, 2));
};


/**
 * @param {!Array<!proto.model.DealTransporterDirectionNoteResponse>} value
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} returns this
*/
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.model.DealTransporterDirectionNoteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.model.DealTransporterDirectionNoteResponse}
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.model.DealTransporterDirectionNoteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse} returns this
 */
proto.deal_transporter_direction_note.ListDealTransporterDirectionNotesResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && protobuf_filter_request_pb.Request.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest;
  return proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new protobuf_filter_request_pb.Request;
      reader.readMessage(value,protobuf_filter_request_pb.Request.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      protobuf_filter_request_pb.Request.serializeBinaryToWriter
    );
  }
};


/**
 * optional filter.Request filter = 1;
 * @return {?proto.filter.Request}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.prototype.getFilter = function() {
  return /** @type{?proto.filter.Request} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_request_pb.Request, 1));
};


/**
 * @param {?proto.filter.Request|undefined} value
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest} returns this
*/
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest} returns this
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_export: (f = msg.getExport()) && protobuf_filter_export_pb.ExportResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse;
  return proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new protobuf_filter_export_pb.ExportResponse;
      reader.readMessage(value,protobuf_filter_export_pb.ExportResponse.deserializeBinaryFromReader);
      msg.setExport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExport();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      protobuf_filter_export_pb.ExportResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional filter.ExportResponse export = 1;
 * @return {?proto.filter.ExportResponse}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.prototype.getExport = function() {
  return /** @type{?proto.filter.ExportResponse} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_export_pb.ExportResponse, 1));
};


/**
 * @param {?proto.filter.ExportResponse|undefined} value
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse} returns this
*/
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.prototype.setExport = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse} returns this
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.prototype.clearExport = function() {
  return this.setExport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.deal_transporter_direction_note.ExportDealTransporterDirectionNotesResponse.prototype.hasExport = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.deal_transporter_direction_note);
